<div class="coupon">
  <div class="content-wrapper">

    <div class=logo>
      <img src="assets/shared/img/physical-coupon/allya-logo-white.svg" alt="Logo Allya">
    </div>

    <div class="main-box">
      <div class="row">
        <div class="col-xs-8">
          <div class="offer-title">{{modalData?.partner?.offerTitle}}</div>
          <div class="partner-name">{{modalData?.partner?.name}}</div>
        </div>
        <div class="col-xs-4 parner-logo">
          <img *ngIf="modalData?.partner?.logo" [src]="modalData.partner.logo" alt="Logo Parceiro">
        </div>
      </div>

      <div *ngIf="modalData?.partner?.guideOfUse" class="coupon-title">{{modalData?.partner?.guideOfUse}}</div>
      <div *ngIf="!modalData?.partner?.guideOfUse">
        <div *ngIf="modalData?.modalType === 'modalCoupon'" class="coupon-title">Apresente o cupom na loja:</div>
        <div *ngIf="modalData?.modalType === 'modalCouponApp'" class="coupon-title">Procure o aplicativo na loja do seu
          dispositivo, instale e utilize o cupom:</div>
        <div *ngIf="modalData?.modalType === 'modalCouponWhatsapp'" class="coupon-title">Solicite seu benefício através do
          whatsapp do parceiro.</div>
        <div *ngIf="modalData?.modalType === 'modalCouponRedirect'" class="coupon-title">Copie o cupom e cole quando
          finalizar a compra.</div>
      </div>
      <div class="coupon-code" *ngIf="modalData?.modalType === 'modalCoupon'">
        <div class="code">{{modalData?.partner?.couponCode}}</div>
      </div>

      <div class="coupon-content" *ngIf="modalData?.modalType === 'modalCouponRedirect' ||
                  modalData?.modalType === 'modalCouponApp' ||
                  modalData?.modalType === 'modalCouponWhatsapp'">
        <span>{{modalData?.partner?.couponCode}}</span>
        <button [class.active]="copied" [copy-clipboard]="modalData?.partner?.couponCode"
          (copied)="onCopy(); trackingEventButton('copy-coupon')">
          {{ copied ? 'copiado' : 'copiar' }}
        </button>
      </div>

      <button *ngIf="modalData?.modalType === 'modalCouponRedirect'" [copy-clipboard]="modalData?.partner?.couponCode"
        class="btn btn-pink cupom-button" (click)="redirectPartner('partner'); trackingEventButton('copy-go-to-site')">
        Copiar e visitar site
      </button>

      <button *ngIf="modalData?.modalType === 'modalCouponWhatsapp'" [copy-clipboard]="modalData?.partner?.couponCode"
        class="btn btn-pink cupom-button" (click)="redirectPartner('whatsapp'); trackingEventButton('go-to-whatsapp')">
        Ir para o whatsapp do parceiro
      </button>

      <div class="row" *ngIf="modalData?.modalType === 'modalCouponApp' && displayStores()">
        <div class="col-sm-6 col-xs-12" style="padding: 10px">
          <button *ngIf="appStore" class="btn cupom-button btn-pink"
            (click)="redirectPartner('app-store'); trackingEventButton('go-to-app-store')">
            <span><i class="fa fa-apple fa-fw" aria-hidden="true"></i>App store</span>
          </button>
        </div>
        <div class="col-sm-6 col-xs-12" style="padding: 10px">
          <button *ngIf="playStore" class="btn cupom-button btn-pink"
            (click)="redirectPartner('google-play'); trackingEventButton('go-to-play-store')">
            <div id="btn-svg">
              <div>
                <svg width="14" height="18" viewBox="0 0 14 18" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                  style="margin-right: 3px;">
                  <path
                    d="M13.21 8.21775C13.0005 8.08638 11.2042 6.87682 10.5301 6.42155L10.5282 6.42L2.36368 0.949891C2.22459 0.851356 2.06862 0.789279 1.90669 0.768005C1.74476 0.746731 1.58079 0.766773 1.42623 0.826729C1.40879 0.833997 1.3924 0.841311 1.37544 0.850318C1.33608 0.865208 1.29759 0.883086 1.26025 0.903835C1.10414 1.01212 0.976072 1.16723 0.889516 1.35284C0.802959 1.53846 0.761115 1.74772 0.768388 1.95861V16.637C0.763433 16.8335 0.803529 17.028 0.884576 17.2006C0.965623 17.3732 1.08471 17.5177 1.22967 17.6193C1.2631 17.6383 1.29755 17.6547 1.33279 17.6686C1.35207 17.6789 1.37044 17.6879 1.39033 17.6961C1.48574 17.7362 1.58622 17.7577 1.6877 17.7598C1.88256 17.7573 2.07347 17.6956 2.24137 17.5808C2.50031 17.4064 10.5282 12.0276 10.5282 12.0276L13.2068 10.2329C13.3724 10.1366 13.5121 9.98968 13.611 9.8079C13.7098 9.62612 13.764 9.41645 13.7676 9.20154C13.7594 8.99454 13.7033 8.79391 13.6052 8.62078C13.5071 8.44765 13.3706 8.30842 13.21 8.21775ZM2.10084 15.3199V3.15277L7.39074 9.22897L2.10084 15.3199ZM5.44395 13.6486L8.3377 10.3166L9.10355 11.1963C8.26101 11.7609 6.83752 12.7148 5.44395 13.6486ZM8.33656 8.13991L5.4066 4.77442L9.10657 7.25335L8.33656 8.13991ZM10.2998 10.3949L9.28353 9.22766L10.3013 8.05571C10.7812 8.3791 11.5291 8.88246 12.0441 9.22647L10.2998 10.3949Z"
                    fill="currentColor" />
                </svg>
                <span id="btn-text">Google play</span>
              </div>
            </div>
          </button>
        </div>
      </div>

    </div>

    <div class="user-info-box">
      <div class="row">
        <div class="col-xs-6 user-name">{{modalData?.user?.name}}</div>
        <div class="col-xs-6 allya-logo align-right">
          <img src="assets/shared/img/svg/logo_allya.svg" alt="Logo Allya">
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6 user-data">
          <img src="assets/shared/img/physical-coupon/user-icon.svg" alt="Ícone Usuário">
          <span>{{ maskCpf() }}</span>
        </div>
        <div class="col-xs-6 user-data align-right" *ngIf="modalData?.user?.phone">
          <img src="assets/shared/img/physical-coupon/phone-icon.svg" alt="Ícone Telefone">
          <span>{{ maskPhone() }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="modalData?.modalType === 'modalCoupon'" class="subtitle">
      {{modalData?.partner?.name}} é um parceiro administrado por Allya
    </div>

    <div class="rules-box">
      <div class="title-rule">Regulamento:</div>
      <div class="text-rule">
        <p [innerHTML]="modalData?.partner?.offerTerm | safeHtml"></p>
      </div>
    </div>

  </div>
</div>
